<template>
    <div v-if="carouselItems.length > 0">
        <b-carousel id="carousel-1" v-model="slide" :interval="4000" img-width="1920"
            img-height="150" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd">
            <div v-for="(item, index) in carouselItems" :key="index">
                <b-carousel-slide :img-src="'/banner.png'"></b-carousel-slide>
            </div>
        </b-carousel>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex';

    export default {
        name: 'Caroussel',
        data() {
            return {
                slide: 0,
                sliding: null
            }
        },
        computed: {
            ...mapState(['live']),
            carouselItems() {
                return this.live.live.carousel;
            }
        },
        methods: {
            onSlideStart() {
                this.sliding = true
            },
            onSlideEnd() {
                this.sliding = false
            }
        },
        watch: {
        
        }
    }
</script>